import styled from 'styled-components';

import TextInputWithSelect from 'components/TextInputWithSelect';

export const Container = styled.div`
  width: 90%;
  max-width: 1024px;
  margin: 30px auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 40px 0 70px;
`;

export const SearchPanel = styled(TextInputWithSelect)`
  grid-template-columns: 200px 1fr;
`;
